import { Partner } from "../../hooks/usePartners/interfaces/Partner";

export const getPartnerIdentifier = (partner: Partner) => {
  return partner.id;
};
